export default __webpack_public_path__ + "static/media/NIAS0360.34I-32914_-19516_0.2cb42d68.jpg";